<template>
  <div>
    <div class="app-title">
      <em-view-title key="viewTitle"
                     :crudState="$_emCommonListMixin_pathType"></em-view-title>
    </div>
    <div class="app-content">
      <div class="card">
        <QualityInspectTemplate ref="templateData"
                                :readonly="templateReadonly"
                                v-if="templateDataLazyLoad"
                                :node-data="data"></QualityInspectTemplate>
        <img :src="imgUrl" alt="" class="img-style" v-if="templateReadonly">
      </div>
      <div v-if="!templateReadonly" class="card mt-2 text-style">
        <b-form-group label="检验任务是否合格：" v-slot="{ ariaDescribedby }" class="m-2">
          <b-form-radio v-model="qualified" :aria-describedby="ariaDescribedby" name="some-radios" :value="null">待定
          </b-form-radio>
          <b-form-radio v-model="qualified" :aria-describedby="ariaDescribedby" name="some-radios" :value="true">合格
          </b-form-radio>
          <b-form-radio v-model="qualified" :aria-describedby="ariaDescribedby" name="some-radios" :value="false">不合格
          </b-form-radio>
        </b-form-group>
        <el-button class="mt-2" type="info" plain @click="saveTemplateData"
                   :loading="templateDataSaving">保 存
        </el-button>
      </div>

    </div>
  </div>

</template>

<script>
import EmCommonApi from "@/mixin/em/common/api";
import QualityInspectTemplate from "@/views/sithMes/quality/inspectTemplate/QualityInspectTemplate";
import emCommonListMixin from "@/mixin/em/common/list";

export default {
  name: "SithMesQualityInspectTemplateSingleView",
  components: {QualityInspectTemplate},
  mixins: [EmCommonApi, emCommonListMixin],
  data() {
    return {
      data: {},
      templateId: null,
      templateDataSaving: false,
      templateReadonly: false,

      qualified: null,
      taskId: null,
      templateDataLazyLoad: false,
      imgUrl: null,
    }
  },
  mounted() {
    this.checkRoute()
  },
  methods: {
    checkRoute() {
      if (this.$route.query.hasOwnProperty('taskId')) {
        this.taskId = this.$route.query.taskId;
        this.checkQualified();
      }
      if (this.$route.params.templateData !== undefined) {
        this.templateReadonly = true;
        this.templateDataLazyLoad = true;
      } else {
        if (this.taskId != null) {
          this.queryDataExist();
        } else {
          this.$router.push('/sithMes/quality/sithMesQualityInspectTaskProcess');
        }
      }
      if (this.$route.query.hasOwnProperty('templateId')) {
        this.templateId = this.$route.query.templateId;
        this.getRemoteData();
      }
    },
    queryDataExist() {
      let api = process.env.VUE_APP_SITHMES_QUALITY_URL + "/sithMesQualityInspectTemplateData/queryExist?taskIds=" + this.taskId;
      this.$_emApiMixin_post(api).then(response => {
        console.log('res')
        console.log(response);
        if (response.data.length > 0) {
          for (let item of response.data) {
            if (item + '' === this.taskId) {
              this.templateReadonly = true;
              this.getTemplateDataOfTask();
            }
          }
        } else {
          this.templateDataLazyLoad = true;
        }
      });
    },
    getTemplateDataOfTask() {
      let api = process.env.VUE_APP_SITHMES_QUALITY_URL + '/sithMesQualityInspectTemplateData/findByFilter';
      this.$_emApiMixin_post(api, {
        taskIdFilter: Number.parseInt(this.taskId)
      }).then((response) => {
        if (response.data.list.length > 0) {
          let tempObject = {};
          for (let item of response.data.list) {
            if (item.value === undefined) {
              item.value = '';
            }
            tempObject[item.templateId + '**' + item.seq] = item;
          }
          this.$set(this.$route.params, 'templateData', tempObject);
        }
      }).finally(() => {
        this.templateDataLazyLoad = true;
      })
    },
    getRemoteData() {
      const _api = `${this.$_emApiMixin_moduleBaseApi("sithMesQualityInspectTemplate")}/sithMesQualityInspectTemplate/templateDetail`
      this.$_emApiMixin_post(_api, {id: this.templateId})
          .then(value => {
            this.data = value.data;
          })
    },
    saveTemplateData() {
      let exportData = this.$refs.templateData.exportData();
      if (exportData.length > 0) {
        this.templateDataSaving = true;
        let _api = process.env.VUE_APP_SITHMES_QUALITY_URL + '/sithMesQualityInspectTemplateData/saveBatch';
        this.$_emApiMixin_post(_api, exportData).then(() => {
          this.$message.success("保存成功");
        }).finally(() => {
          this.templateDataSaving = false;
        })
      }

      if (this.qualified != null) {
        let api = process.env.VUE_APP_SITHMES_QUALITY_URL + "/sithMesQualityInspectTask/task/"
            + (this.qualified ? 'qualified' : 'unqualified')
            + "?taskId=" + this.taskId
            + "&qualified=" + this.qualified;
        this.$_emApiMixin_post(api);
      }
    },
    checkQualified() {
      let api = process.env.VUE_APP_SITHMES_QUALITY_URL + '/sithMesQualityInspectTask/findByFilter';
      this.$_emApiMixin_post(api, {
        idFilter: this.taskId
      }).then(response => {
        console.log(response);
        let data = response.data.list;
        if (data != null && data.length > 0) {
          let png = '';
          let qualified = data[0].qualified;
          switch (qualified) {
            case true:
              png = 'qualified';
              break;
            case false:
              png = 'unQualified';
              break;
            default:
              png = 'checking';
              break;
          }
          this.imgUrl = require('@/assets/images/qualifyInspectTask/' + png + '.png');
          this.qualified = qualified === undefined ? null : qualified;
        }
      });
    }
  }
}
</script>

<style scoped>
.text-style {
  font-size: 1rem;
  font-weight: bold;
  padding: 2px;
}

.img-style {
  width: 81px;
  height: 64px;
  position: absolute;
  top: 1rem;
  right: 1rem;
}
</style>